import React from 'react';

import { EmptyState } from '../../EmptyState';
import {
  DATA_GRID_DEFAULT_EMPTY_DESCRIPTION,
  DATA_GRID_DEFAULT_EMPTY_TITLE,
} from '../constants';
import { DataGridEmptyStateConfig } from '../types';
import { DataGridStatePanel } from './DataGridStatePanel';

export interface DataGridEmptyStateProps {
  config?: DataGridEmptyStateConfig;
}

const DataGridEmptyState = ({ config }: DataGridEmptyStateProps) => (
  <DataGridStatePanel className="h-[320px] bg-bg-secondary">
    {config?.render ? (
      config.render()
    ) : (
      <EmptyState
        heading={config?.title ?? DATA_GRID_DEFAULT_EMPTY_TITLE}
        description={
          config?.description ?? DATA_GRID_DEFAULT_EMPTY_DESCRIPTION
        }
        primaryAction={
          config?.action
            ? {
                label: config.action.text,
                onClick: config.action.onClick,
                variant: 'secondary',
              }
            : undefined
        }
      />
    )}
  </DataGridStatePanel>
);

export { DataGridEmptyState };
